import React, { useState, useEffect, useCallback, useRef } from 'react';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { SVGPayment, SVGPopupErr, SVGRing } from 'assets/svg';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'redux/store';
import globalAction from '../../../../redux/actions/global/globalAction';
import './styles.scss';
import { ParamsPayment, PopupPaymentActions } from 'pages/order/payment/types';
import { Language } from 'shared/Language';
import { fetchOrderDetail, fetchPayment } from 'service/orderService';
import PopupSuccess, { ModalAction } from 'pages/payment/popup-success';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import LoadingTable from 'components/LoadingTable';
import PopupPayment from 'pages/payment/popup-payment';
import { PopupPrintfAction } from 'components/popup-print/types';
import PopupPrint from 'components/popup-print';
import PopupPrintOrder from 'components/PopupPrintfOder';
import { OrderModel } from 'models/order';
import { TypePrint } from 'constants/AppEnums';
import PopupErr from 'components/PopupErr';

function FooterCart({
    createOrder,
    bookedList,
    orderList
}) {
    const [cost, setCost] = useState<number>(0);
    const [isLoading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const [totalListPrice, setTotalListPrice] = useState<number>(0);
    // ====================
    // SELECTORS
    // ====================
    const { currentnumElder, currentnumChildren } = useSelector((state: AppState) => state.global);
    const { locationCode } = useSelector((state: AppState) => state.home);
    const { currentOrderId } = useSelector((state: AppState) => state.currentOrderId);
    const refPopupPayment = useRef<PopupPaymentActions>(null);
    const refPopupSuccess = useRef<ModalAction>(null);
    const refPopupPrintf = useRef<PopupPrintfAction>(null);
    const refPopupOrder = useRef<PopupPrintfAction>(null);
    const [data, setData] = useState<OrderModel>();
    const refErr = useRef<PopupPrintfAction>(null);

    const _user = localStorage.getItem('Apec_Account');
    const user = _user && JSON.parse(_user);
    // ====================
    // DISPATCH
    // ====================
    const dispatch = useDispatch();
    const _updateNumberElder = useCallback((numElder: number) => dispatch(globalAction.updateNumberElder(numElder)), []);
    const _updateNumberChildren = useCallback((numChildren: number) => dispatch(globalAction.updateNumberChildren(numChildren)), []);
    // =====================
    //  HOOKS
    // =====================
    useEffect(() => {
        setCost(0);
        if (bookedList.length < 1) {
            _updateNumberElder(0);
            _updateNumberChildren(0);
        }
        bookedList.filter(item => item.flag !== 'DELETE').map((item: any) => {
            setCost(pre => pre + item?.price * item?.qty);
        });
    }, [_updateNumberChildren, _updateNumberElder, bookedList]);

    useEffect(() => {
        const total = orderList.reduce((a, i) => a + i.qty * i.price, 0);
        setTotalListPrice(total);
    }, [orderList]);

    const formatMoney = (number) => {
        if (typeof number === 'number') {
            const optionsVND = { style: 'currency', currency: 'VND', currencyDisplay: 'code' };
            return number.toLocaleString('vi-VN', optionsVND).split('V')[0];
        }
        return number;
    };

    useEffect(() => {
        getOderDetail(currentOrderId);
    }, [currentOrderId]);

    const getOderDetail = useCallback(async (id?: string) => {
        if (id) {
            setLoading(true);
            const res = await fetchOrderDetail(currentOrderId);
            setLoading(false);
            if (res.message === 'Success') {
                const _data = res.metadata[0] as OrderModel;
                setData(_data);
            } else {
                toast.error(Language.err.notFound, {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
        }
    }, []);

    const onPaymentConfirm = useCallback(async () => {
        // const _params = params;
        // setLoading(true);
        // const res = await fetchPayment(_params);
        // setLoading(false);
        // if (res.message === 'Success') {
        refPopupSuccess.current.showModal();
        // } else {
        //     toast.error(res.message || Language.err.paymentErr, {
        //         position: 'top-right',
        //         theme: 'colored'
        //     });
        // }
    }, []);

    const onNavigateOrderPaid = () => {
        navigate('/order-paid');
    };

    const onShowPayment = () => {
        refPopupPayment.current.showModal(currentOrderId);
    };

    const setOpenModalPrint = () => {
        refPopupPrintf.current.showModal();
    };

    const onPrint = (type) => {
        if (type === TypePrint.BILL) {
            refErr.current.showModal();
        } else {
            console.log('data ==', data);

            refPopupOrder.current.showModal(type, data);
        }
    };

    return (
        <div className="footer">
            <div className="total-value">
                <div className="total-people">
                    <PeopleOutlineIcon fontSize='small' /> Adult:
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ marginRight: 5 }} onClick={() => {
                            if (currentnumElder > 0) {
                                _updateNumberElder(currentnumElder - 1);
                            }
                        }}>
                            <RemoveIcon style={{ cursor: 'pointer' }} fontSize='small' />
                        </div>
                        {currentnumElder}
                    </div>
                    <div onClick={() => {
                        {
                            _updateNumberElder(currentnumElder + 1);
                        }
                    }}>
                        <AddIcon style={{ cursor: 'pointer' }} fontSize='small' />
                    </div>
                    <span style={{ width: 30 }} />
                    <ChildCareIcon fontSize='small' /> Child:
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ marginRight: 5 }} onClick={() => {
                            if (currentnumChildren > 0) {
                                _updateNumberChildren(currentnumChildren - 1);
                            }
                        }}>
                            <RemoveIcon style={{ cursor: 'pointer' }} fontSize='small' />
                        </div>
                        {currentnumChildren}
                    </div>
                    <div onClick={() => {
                        _updateNumberChildren(currentnumChildren + 1);
                    }
                    }>
                        <AddIcon style={{ cursor: 'pointer' }} fontSize='small' />
                    </div>
                </div>
                <hr></hr>
                <div className="total-price">
                    <span>Total: </span>
                    <span style={{ color: '#DC3545' }}>{formatMoney(cost + totalListPrice)}đ</span>

                </div>
            </div>

            <div className='button-order-bottom'>
                <Button variant="contained"
                    onClick={() => createOrder(bookedList)}
                    disabled={orderList.length === 0 && bookedList.length === 0}
                    style={{
                        textTransform: 'none',
                        flex: 1,
                        color: '#fff',
                        background: orderList.length === 0 && bookedList.length === 0 ? '#CBCBCD' : '#B51929',
                        padding: 10,
                        borderRadius: 4
                    }}>
                    <SVGRing />
                    <span className='color-white text-normal regular mgl-5'>Calling</span>
                </Button>
                <Button
                    variant="contained"
                    style={{
                        textTransform: 'none',
                        flex: 1,
                        color: '#fff',
                        background: bookedList.length === 0 ? '#CBCBCD' : '#FFA731',
                        borderRadius: 4,
                        padding: 10
                    }}
                    onClick={onShowPayment}
                    disabled={bookedList.length === 0}
                ><SVGPayment />Payment</Button>
            </div>
            <PopupPayment ref={refPopupPayment} title={Language.payment.payment} onPressConfirm={onPaymentConfirm} setOpenModalPrint={setOpenModalPrint} />
            <PopupSuccess ref={refPopupSuccess} onConfirm={onNavigateOrderPaid} />
            <PopupPrint ref={refPopupPrintf} title={Language.payment.print} onConfirm={onPrint} />
            <PopupPrintOrder ref={refPopupOrder} />
            <PopupErr
                ref={refErr}
                title={Language.err.errPopupPrint}
                content={Language.err.contentErrPopupPrint}
                icon={<SVGPopupErr />}
            />
            {isLoading && <LoadingTable />}
        </div>

    );
}
export default FooterCart;
